import { capitalizeIfLower, fromNow } from '@btime/helpers'
import { compose, pathOr, prop } from 'ramda'
import React from 'react'

import { useChecklist } from './_load/ChecklistLoader'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import LabelValue from '../../../components/presentation/LabelValue'
import UsagesTags from '../../../containers/checklists/UsagesTags'

const ChecklistDetails = () => {
  const checklist = useChecklist()

  const typeName = compose(capitalizeIfLower, pathOr('Sem tipo', ['type', 'name']))(checklist)

  const updatedAt = compose(fromNow, prop('updatedAt'))(checklist)

  return (
    <FlexGrid justify="flex-start" align="flex-start" paddingGutter={0.5} wrap>
      <FlexCol width="50%">
        <LabelValue label="Tipo" value={typeName} />
      </FlexCol>

      <FlexCol width="50%">
        <LabelValue label="Última vez atualizado" value={updatedAt} />
      </FlexCol>

      <FlexCol width="50%">
        <LabelValue label="Disponível em">
          <UsagesTags value={checklist.usages} />
        </LabelValue>
      </FlexCol>
    </FlexGrid>
  )
}

export default ChecklistDetails
